/* src/app/shared/components/table/table.component.scss */
:root {
  --cf-brand: #e3fd64;
  --cf-brand-dark: #4d7a00;
  --cf-brand-light: #f9ffe0;
  --cf-chrome: #1d2530;
  --cf-bg: #f4f6f8;
  --cf-surface: #ffffff;
  --cf-surface-hover: #f9fafc;
  --cf-text: #1a1d23;
  --cf-text-muted: #6b7280;
  --cf-text-on-dark: rgba(255, 255, 255, 0.87);
  --cf-border: #e5e7eb;
  --cf-border-strong: #d1d5db;
  --cf-radius: 8px;
  --cf-radius-sm: 4px;
  --cf-radius-lg: 12px;
  --cf-shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06);
  --cf-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.07), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --cf-success: #16a34a;
  --cf-warning: #d97706;
  --cf-error: #dc2626;
}
.mat-mdc-form-field {
  color: var(--cf-text);
}
.content-router {
  margin-left: 2%;
}
.th-bg {
  color: #1a1d23;
}
table {
  width: 100%;
  background: transparent !important;
}
span.paid {
  color: green;
}
span.notPaid {
  color: red;
}
.icon-attachment:before {
  font-family: "Material Icons";
  content: "attachment";
  color: #8cb7c9;
  font-size: x-large;
}
.icon-photo:before {
  font-family: "Material Icons";
  content: "photo";
  color: #8cb7c9;
  font-size: x-large;
}
.icon-folder:before {
  font-family: "Material Icons";
  content: "folder";
  color: #6b7280;
  font-size: x-large;
}
.icon-grid_on:before {
  font-family: "Material Icons";
  content: "grid_on";
  color: #8cb7c9;
  font-size: x-large;
}
.icon-text_format:before {
  font-family: "Material Icons";
  content: "text_format";
  color: #8cb7c9;
  font-size: x-large;
}
.icon-arrendador {
  content: url(/assets/img/home.png);
}
.icon-redCircle,
.icon-greenCircle {
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin: auto;
}
.icon-redCircle {
  background: #dc2626;
}
.icon-greenCircle {
  background: #16a34a;
}
.cf-dot {
  display: block;
  text-align: center;
  font-size: 12px;
  line-height: 1;
}
.cf-dot--green {
  color: #16a34a;
}
.cf-dot--red {
  color: #dc2626;
}
.icon-expenseByConvfact {
  content: url(/assets/img/logo-mini.png);
}
.mat-mdc-cell {
  color: #1a1d23;
  padding-left: 5px;
  cursor: pointer;
}
.bold {
  font-weight: bold;
}
.unread {
  background-color: lightgray;
}
.read {
  background-color: white;
}
.remark {
  background-color: lightyellow;
}
.tableFilters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: var(--cf-surface);
  border-bottom: 1px solid var(--cf-border);
  color: var(--cf-text);
}
.tableFilters > .mat-mdc-form-field,
.tableFilters .filter-field {
  width: 200px;
  margin: 0;
}
.butonera {
  display: flex;
  align-items: center;
  padding-bottom: 2px;
}
::ng-deep [filterBarActions] {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}
::ng-deep .mat-mdc-select-panel,
::ng-deep .mat-mdc-option {
  color: var(--cf-text);
}
.row_color_green .mat-mdc-cell > :not(button) {
  color: green !important;
  font-weight: 500;
}
.row_color_red .mat-mdc-cell > :not(button) {
  color: red !important;
  font-weight: 500;
}
@media (max-width: 1199.98px) {
  .tableFilters > .mat-mdc-form-field {
    width: 180px;
  }
}
@media (max-width: 859px) {
  .tableFilters .container-fluid {
    padding: 0 !important;
  }
}
@media (max-width: 767px) {
  .mat-elevation-z8.toplineBlue th .mat-mdc-checkbox {
    margin-right: 10px;
  }
  .tableFilters {
    padding: 10px 12px;
    gap: 8px;
  }
  .tableFilters > .mat-mdc-form-field {
    width: 100%;
  }
}
.totals-container {
  margin-top: 1rem;
}
.totals-container .total-card {
  background: #fff;
  border-radius: 12px;
  padding: 12px 20px;
  margin: 6px;
  text-align: center;
  min-width: 230px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
}
.totals-container .total-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}
.totals-container .total-card .label {
  font-size: 13px;
  color: #666;
  margin: 0;
}
.totals-container .total-card .value {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}
.totals-container .total-card .text-danger {
  color: #d9534f;
}
.totals-container .total-card .text-success {
  color: #28a745;
}
.totals-container .total-card .text-warning {
  color: var(--cf-warning);
}
::ng-deep .comments-tooltip {
  max-width: 420px;
  white-space: pre-line;
  line-height: 1.4;
  font-size: 13px;
}
/*# sourceMappingURL=table.component.css.map */
